export default "__VITE_ASSET__BIqf6SPo__"